// Numero WhatsApp para notificacoes
const WHATSAPP_NUMBER = '5547996067992'

// Cores preset para selecao de marca
export const CORES_PRESET = [
  '#8B5CF6', '#EC4899', '#EF4444', '#F97316', '#EAB308',
  '#22C55E', '#14B8A6', '#06B6D4', '#3B82F6', '#6366F1',
  '#000000', '#FFFFFF'
]

export function getPrimeiroNome(nomeCompleto: string): string {
  return nomeCompleto.split(' ')[0] || nomeCompleto
}

export function formatarTelefone(valor: string): string {
  const numeros = valor.replace(/\D/g, '')
  if (numeros.length <= 2) return numeros.length ? `(${numeros}` : ''
  if (numeros.length <= 7) return `(${numeros.slice(0, 2)}) ${numeros.slice(2)}`
  if (numeros.length <= 11) return `(${numeros.slice(0, 2)}) ${numeros.slice(2, 7)}-${numeros.slice(7)}`
  return `(${numeros.slice(0, 2)}) ${numeros.slice(2, 7)}-${numeros.slice(7, 11)}`
}

export function validarEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

export function validarTelefone(telefone: string): boolean {
  const numeros = telefone.replace(/\D/g, '')
  return numeros.length >= 10 && numeros.length <= 11
}

function getLabelObjetivo(objetivo: string | null): string {
  const labels: Record<string, string> = {
    leads: 'Gerar leads/clientes',
    sales: 'Vender online',
    portfolio: 'Mostrar portfolio',
    branding: 'Fortalecer marca',
    info: 'Site informativo'
  }
  return labels[objetivo || ''] || 'Criar site'
}

function getLabelUrgencia(urgencia: string | null): string {
  const labels: Record<string, string> = {
    '7_days': 'Urgente (7 dias)',
    '15_30_days': 'Normal (15-30 dias)',
    'negotiate': 'A negociar'
  }
  return labels[urgencia || ''] || 'A definir'
}

export function getWhatsAppUrl(formData: { nome: string; email: string; objective: string | null; urgency: string | null }): string {
  const message = `Ola! Sou ${formData.nome} e acabei de preencher o formulario no site.\n\n` +
    `Email: ${formData.email}\n` +
    `Objetivo: ${getLabelObjetivo(formData.objective)}\n` +
    `Urgencia: ${getLabelUrgencia(formData.urgency)}\n\n` +
    `Gostaria de saber mais sobre os proximos passos!`

  const encodedMessage = encodeURIComponent(message)

  if (typeof window !== 'undefined') {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
    if (isMobile) {
      return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`
    }
  }
  return `https://web.whatsapp.com/send?phone=${WHATSAPP_NUMBER}&text=${encodedMessage}`
}
